import { ENDPOINT } from "../../constants/endpoint.js";
import axios from "axios";
import _ from "lodash";

const token =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjg5NTI3MjI1LCJleHAiOjI3MjY2ODk2MDU1MjI1LCJqdGkiOiI3M2EwMjM0Ni05NzQxLTQzZTctYmZiMC05NTM5ZmZkNjlmNTkifQ.Ox2TLGEDhV-nPaSpenQu_hoSAi4pX0gjF3RXjb5h5DQ";

const state = {
  loading: false,
  error: {},
  transferData: [],
  oilTransfers: [],
  oilPrice: null,
  tankerOilTransferForPrint: null
};
const getters = {
  getterOilTransferData: (state) => () => {
    return state.oilTransfers
  },
};
const mutations = {
  SET_OIL_TRANSFER: (state, payload) => {
    state.oilTransfers = payload;
  },
  LOADING_TRANSFER_DATA(state, payload) {
    state.loading = payload.loading;
  },
  SET_OIL_TRANSFER_NULL(state) {
    state.oilTransfers = [];
  },

};

const actions = {
  resetOilTransfer: ({ commit }) => {
    commit("SET_OIL_TRANSFER_NULL");
  },
  setOilTransfer: ({ commit }, payload) => {
    commit("SET_OIL_TRANSFER", payload);
  },
  async getOilTransfers(context, payload) {
    const url = ENDPOINT.GET_OIL_TRANSFERS_FLOW_METER;
    // http://flow_meter.excise-online.com/batch_logs?per_page=2000&q[start_date_gteq]=2023-08-17 00:00&q[end_date_lteq]=2023-08-18 00:00
    await $.ajax({
      url: `${url}?per_page=10000&q[start_date_gteq]=${payload.start}&q[end_date_lteq]=${payload.end}`,
      type: 'GET',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`)
      },
      success: (result) => {
        const uniq = _.uniqBy(result, 'start_date', 'end_date', 'volume', 'mmsi_tanker', 'order_per_day');
        context.commit("SET_OIL_TRANSFER", uniq);
      },
      error: (e) => {
        // error
      },
      complete: () => {
        // complete
      },
    })

    // const params = payload ? {
    //   // startDate: payload.start,
    //   // endDate: payload.end,
    //   per_page: 2000
    // } : {}

    // await axios
    //   .get(url)
    //   .then(async (res) => {
    //     console.log("res ", res);
    //     context.commit("SET_OIL_TRANSFER", res.data);
    //   })
    //   .catch((e) => {
    //   })
    //   .finally(() => {
    //   });
  },
  clearOilTransfers(context) {
    context.commit("SET_OIL_TRANSFER", []);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
